export default "__VITE_ASSET__BhMmb5Aq__"